/* NPFC Growing Advice guides (2026-09-25).
   Small and progressive: everything reads without this file. It does three things.
   1. The "On this page" list is open on wide screens and closed on narrow ones (native details element).
   2. Timeline bars, seasons and stages draw in once when they scroll into view (motion-safe only).
   3. Nothing here relies on hover. Tabs use assets/npfc-tabs.js, the site's one tabs controller. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. contents
  var wide = window.matchMedia ? window.matchMedia('(min-width:901px)') : { matches: true, addEventListener: function () {} };
  function syncToc() {
    [].forEach.call(document.querySelectorAll('.g-toc details'), function (d) {
      if (wide.matches) d.setAttribute('open', ''); else d.removeAttribute('open');
    });
  }
  syncToc();
  if (wide.addEventListener) wide.addEventListener('change', syncToc); else if (wide.addListener) wide.addListener(syncToc);

  // 2. draw-in
  var targets = [].slice.call(document.querySelectorAll('.g-cal-table td.on, .g-cal-list .bar i, .g-stage, .g-season'));
  if (!targets.length) return;
  if (reduce || !('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('in'); }); return; }
  document.documentElement.classList.add('g-js-anim');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      var idx = el.getAttribute('data-m') || el.getAttribute('data-i');
      if (idx) el.style.transitionDelay = (parseInt(idx, 10) * 45) + 'ms';
      el.classList.add('in');
      io.unobserve(el);
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
  targets.forEach(function (t) { io.observe(t); });
  // a failsafe: never leave content hidden if the observer is throttled (background tab, print)
  window.setTimeout(function () { targets.forEach(function (t) { t.classList.add('in'); }); }, 6000);
})();
